// Route guard for the admin section: only super-admins may enter.
// Runs as a named (per-page) middleware applied via definePageMeta in
// app/pages/app/admin.vue, so the page never mounts for non-super-admins
// (avoids the brief flash the old onMounted redirect caused).
//
// Firebase auth is client-side, so we must await readiness before deciding —
// redirecting during the auth-loading window would lock out legitimate
// super-admins. Mirrors the waitForAuth() gating used elsewhere (auth.global.ts).
export default defineNuxtRouteMiddleware(async () => {
  const { waitForAuth } = useAuth()
  const { profile, ensure: ensureProfile } = useUserProfile()

  await waitForAuth()
  await ensureProfile()

  if (!profile.value?.is_superadmin) {
    return navigateTo('/app')
  }
})
